<template>
  <div id="askWechat">
    <div class="tab-container">
      <p class="tab" :class="{active: activeTab === 0}" @click="switchTab(0)">
        <span class="context">我索要的用户</span>
        <span class="line"></span>
      </p>
      <p class="tab" :class="{active: activeTab === 1}" @click="switchTab(1)">
        <span class="context">索要我的用户</span>
        <span class="line"></span>
      </p>
    </div>
    <van-list v-model="isLoading" :finished="isFinished" :finished-text="!list || list.length > 0 ? '没有更多了' : ''"
      @load="fetchData" class="users-list">

      <dl class="users-list" v-if="list && list.length > 0">
        <dd class="users-item" v-for="(item, index) in list" :key="index" @click="jump(item)">
          <div class="head-box">
            <div class="img-box">
              <img v-lazy="item.headPicUrl" alt="" class="img" />
            </div>
          </div>
          <div class="infomation">
            <p class="name-box"><span class="name">{{item.nickName}}</span></p>
            <p class="sentence">
              现居{{`${parseInt(item.cityId) === 900000 ? (item.country + ' ' + item.state) : areaData['city_list'][item.cityId]}`}}
              {{item.age}}岁 {{item.high}}cm {{educationMap[item.education]}}
              {{item.ifStudent ? '在读' : item.job}}</p>
          </div>
        </dd>
      </dl>

      <dl class="users-list" v-if="list && list.length === 0">
        <dd>
          <p class="no-message-tips">当前暂无数据</p>
          <img src="~@/assets/img/no-search-result.png" alt="" class="no-message-img" />
        </dd>
      </dl>
    </van-list>

    <banModal v-model="showModal" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import banModal from './component/banModal'

export default {
  name: 'Ask',
  components: {
    banModal
  },
  data () {
    return {
      activeTab: 0,
      temp_data: {
        0: {
          isLoading: false,
          isFinished: false,
          currentPage: 1,
          pageSize: 20,
          list: null
        },
        1: {
          isLoading: false,
          isFinished: false,
          currentPage: 1,
          pageSize: 20,
          list: null
        }
      },
      showModal: false
    }
  },
  computed: {
    ...mapState({
      educationMap: 'educationMap',
      areaData: 'areaData'
    }),
    ...mapGetters({
      userId: 'userId'
    }),
    list: {
      get() {
        return this.getOrSetValue('list')
      },
      set(val) {
        this.getOrSetValue('list', val)
      }
    },
    isLoading: {
      get() {
        return this.getOrSetValue('isLoading')
      },
      set(val) {
        this.getOrSetValue('isLoading', val)
      }
    },
    isFinished: {
      get() {
        return this.getOrSetValue('isFinished')
      },
      set(val) {
        this.getOrSetValue('isFinished', val)
      }
    },
    currentPage: {
      get() {
        return this.getOrSetValue('currentPage')
      },
      set(val) {
        this.getOrSetValue('currentPage', val)
      }
    },
    pageSize: {
      get() {
        return this.getOrSetValue('pageSize')
      },
      set(val) {
        this.getOrSetValue('pageSize', val)
      }
    }
  },
  methods: {
    switchTab (tab) {
      if (tab === this.activeTab) return
      this.activeTab = tab
    },
    getOrSetValue(type, val) {
      if (this.activeTab === null) {
        return undefined
      }
      if (val != undefined) {
        this.temp_data[this.activeTab][type] = val
      } else {
        return this.temp_data[this.activeTab][type]
      }
    },
    fetchData () {
      this.isLoading = true
      this.$http('/api/member/action/list', {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        // 30: 我索要   33: 索要我的
        actionType: this.activeTab === 0 ? 30 : 33
      }, 'get').then(res => {
        this.isLoading = false
        if (res.code === '0000' && res.data) {
          const data = res.data
          if (this.currentPage === 1) {
            this.list = data.data
          } else {
            this.list = [...this.list, ...data.data]
          }
          try {
            if (this.pageSize > data.data.length || !this.userId) {
              this.isFinished = true
            }
          } catch (err) {
            this.isFinished = true
          }
          this.currentPage++
        } else {
          this.isFinished = true
          this.$toast(res.msg)
        }
      }, err => {
        this.isFinished = true
        this.isLoading = false
        this.$toast(err)
      }).finally(() => {
        this.$root.closeLoading()
      })
    },
    jump (item) {
      if (item.singleStatus === 6 || item.singleStatus === 7) {
        this.showModal = true
      } else {
        this.$router.push({
          path: `/info-${item.mid}.html`
        })
      }
    }
  }
}
</script>

<style lang="scss">
#askWechat {
  .tab-container {
    display: flex;
    border-bottom: 1px solid #E4E4E4;
  }
  .tab {
    position: relative;
    flex: 1 1 auto;
    width: 0;
    padding: 20px 20px 18px;
    text-align: center;
    &.active {
      .context {
        color: #4A4A4A;
      }
      .line {
        opacity: 1;
      }
    }
  }
  .context {
    color: #9B9B9B;
    font-size: 42px;
    line-height: 60px;
  }
  .line {
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 114px;
    height: 10px;
    opacity: 0;
    background: #4A4A4A;
    transform: translateX(-50%);
  }
}
</style>
